import * as ActionTypes from './actionTypes'

export const updateDafferedPayment = (payload) =>{
    return {
        type:ActionTypes.UPDATE_DAFFERED_PAYMENT,
        payload:payload
    }


}
